const locale = {
  LOADER_TEXT: 'Cargando',
  MAIN_ARIA_LABEL: 'Contenido principal',
  ASIDE_ARIA_LABEL: 'Barra lateral de navegación',
  FOOTER_ARIA_LABEL: 'Pie de página',
  SKIP_TO_MAIN_CONTENT: 'Saltar al contenido principal',
};

export default locale;
